import { render, staticRenderFns } from "./floatBtn.vue?vue&type=template&id=6b0f211e"
import script from "./floatBtn.vue?vue&type=script&lang=js"
export * from "./floatBtn.vue?vue&type=script&lang=js"
import style0 from "./floatBtn.vue?vue&type=style&index=0&id=6b0f211e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports